module.exports = __webpack_public_path__ + "img/06-oval-convex-2.6121d983.svg";